import { default as AsyncValueUpdateModule } from "./asyncValueUpdate-module";

export default AsyncValueUpdateModule;
